var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { attrs: { shadow: "never", "body-style": { padding: "20px" } } },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "hasPermi",
                  rawName: "v-hasPermi",
                  value: ["distribution:store:guarantee:group:add"],
                  expression: "['distribution:store:guarantee:group:add']",
                },
              ],
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.openEditor()
                },
              },
            },
            [_vm._v(" 新增保障组合 ")]
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "mt20",
              attrs: { data: _vm.rows, size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              false
                ? _c("el-table-column", {
                    attrs: { prop: "id", label: "ID", width: "80" },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { prop: "name", label: "组合名称", "min-width": "180" },
              }),
              _c("el-table-column", {
                attrs: { label: "保障条款", "min-width": "360" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(scope.row.guaranteeList, function (item) {
                        return _c(
                          "el-tag",
                          {
                            key: item.id,
                            staticClass: "mr10",
                            attrs: { size: "small" },
                          },
                          [_vm._v(_vm._s(item.name))]
                        )
                      })
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "createTime", label: "创建时间", width: "170" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "130", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: [
                                  "distribution:store:guarantee:group:edit",
                                ],
                                expression:
                                  "['distribution:store:guarantee:group:edit']",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.openEditor(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: [
                                  "distribution:store:guarantee:group:delete",
                                ],
                                expression:
                                  "['distribution:store:guarantee:group:delete']",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.remove(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.form.id ? "编辑保障组合" : "新增保障组合",
            visible: _vm.visible,
            width: "680px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            closed: _vm.clearForm,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "90px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "组合名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "60", "show-word-limit": "" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "name",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "保障条款", prop: "ids" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      staticClass: "guarantee-options",
                      model: {
                        value: _vm.form.ids,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "ids", $$v)
                        },
                        expression: "form.ids",
                      },
                    },
                    _vm._l(_vm.options, function (item) {
                      return _c(
                        "el-checkbox",
                        {
                          key: item.id,
                          attrs: { label: item.id, disabled: !item.isShow },
                        },
                        [
                          _vm._v(" " + _vm._s(item.name)),
                          !item.isShow
                            ? _c("span", [_vm._v("（已停用）")])
                            : _vm._e(),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.submit },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }